/* 130R — calculadora de frete e prazo da página de produto (snippets/r130-frete.liquid).
   Consulta o app 130R (GET /site/frete, mesmas opções e prazos do checkout, pelo app de frete da loja) e mostra o prazo
   mais rápido em destaque e todas as opções. O CEP fica lembrado em localStorage['r130_cep'].
   Funções puras testadas em tests/test_r130_frete.js.
   Spec: docs/superpowers/specs/2026-10-19-calculadora-frete-site-design.md (branch feat/site-frete-calc). */
(function () {
  'use strict';
  var ERRO = 'Não conseguimos calcular agora. Veja as opções no fechamento do pedido.';
  var ERRO_CEP = 'CEP inválido. Confira os 8 números.';

  function cep(s) { var d = String(s == null ? '' : s).replace(/\D/g, ''); return d.length === 8 ? d : null; }
  function mascara(s) {
    var d = String(s == null ? '' : s).replace(/\D/g, '').slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }
  function url(endpoint, variante, qtd, c) {
    return endpoint + '?variante=' + encodeURIComponent(variante) + '&qtd=' + encodeURIComponent(qtd) + '&cep=' + encodeURIComponent(c);
  }
  function dias(n) { return n === 1 ? '1 dia útil' : n + ' dias úteis'; }
  function prazo(min, max) {
    if (max == null) return '';
    return (min == null || min === max) ? 'até ' + dias(max) : 'de ' + min + ' a ' + dias(max);
  }
  function preco(v) {
    if (!v) return 'Grátis';
    var p = Number(v).toFixed(2).split('.');
    return 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  /* o app do Melhor Envio (Gadol) põe "(Melhor Envio)" no fim de cada opção; o cliente vê só o serviço */
  function nome(s) { return String(s == null ? '' : s).replace(/\s*\(melhor envio\)\s*$/i, '').trim(); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return '&#' + ch.charCodeAt(0) + ';'; }); }

  function html(r) {
    if (!r || !r.opcoes || !r.opcoes.length) return '<p class="r130-frete__erro">' + ERRO + '</p>';
    var h = '';
    var rapido = r.mais_rapido;
    if (rapido && rapido.dias_max != null) {
      h += '<p class="r130-frete__destaque"><strong>Chega em até ' + dias(rapido.dias_max) + '</strong> · ' + esc(nome(rapido.nome)) + '</p>';
    }
    h += '<ul class="r130-frete__lista" role="list">';
    r.opcoes.forEach(function (o) {
      h += '<li><span class="r130-frete__nome">' + esc(nome(o.nome)) + '</span><span class="r130-frete__preco">' + preco(o.preco) +
        '</span><span class="r130-frete__prazo">' + prazo(o.dias_min, o.dias_max) + '</span></li>';
    });
    h += '</ul><p class="r130-frete__nota">Valores e prazos do fechamento do pedido para o CEP ' + mascara(r.cep || '') + '.</p>';
    return h;
  }

  function lerCampo(seletor, padrao) {
    var form = document.querySelector('form[action*="/cart/add"]');
    var el = form && form.querySelector(seletor);
    return el && el.value ? el.value : padrao;
  }

  function ligar(caixa) {
    var campo = caixa.querySelector('input[name="r130-cep"]');
    var botao = caixa.querySelector('[data-r130-frete-calcular]');
    var saida = caixa.querySelector('[data-r130-frete-resultado]');
    if (!campo || !botao || !saida) return;
    try { campo.value = mascara(localStorage.getItem('r130_cep') || ''); } catch (e) {}
    campo.addEventListener('input', function () { campo.value = mascara(campo.value); });
    campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcular(); } });
    botao.addEventListener('click', calcular);

    function calcular() {
      var c = cep(campo.value);
      if (!c) { saida.innerHTML = '<p class="r130-frete__erro">' + ERRO_CEP + '</p>'; campo.focus(); return; }
      try { localStorage.setItem('r130_cep', c); } catch (e) {}
      var variante = lerCampo('[name="id"]', caixa.getAttribute('data-variante'));
      var qtd = Math.max(1, Math.min(20, parseInt(lerCampo('[name="quantity"]', '1'), 10) || 1));
      saida.innerHTML = '<p class="r130-frete__carregando">Calculando…</p>';
      botao.disabled = true;
      var controle = window.AbortController ? new AbortController() : null;
      var limite = setTimeout(function () { if (controle) controle.abort(); }, 15000);
      fetch(url(caixa.getAttribute('data-endpoint'), variante, qtd, c), { credentials: 'omit', signal: controle ? controle.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (r) { saida.innerHTML = html(r); })
        .catch(function () { saida.innerHTML = html(null); })
        .then(function () { clearTimeout(limite); botao.disabled = false; });
    }
  }

  window.r130Frete = { cep: cep, mascara: mascara, url: url, prazo: prazo, preco: preco, nome: nome, html: html };
  function iniciar() { Array.prototype.forEach.call(document.querySelectorAll('[data-r130-frete]'), ligar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
